import { CSSProperties } from "react";
import styles from "./Skeleton.module.css";

interface Props {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  style?: CSSProperties;
}

export function Skeleton({ width = "100%", height = 16, radius, style }: Props) {
  return (
    <div
      className={styles.skeleton}
      style={{
        width,
        height,
        borderRadius: radius ?? "var(--radius-sm)",
        ...style,
      }}
      aria-hidden
    />
  );
}
